import { css } from '@emotion/css';

export const tabsOpenedCounter = css`
	width: 143px;
	padding: 10px 22px !important;

	display: flex;
	align-items: center;
	justify-content: space-between;

	z-index: -1;

	svg {
		margin-left: 5px;
	}
`;
